// extracted by css-extract-rspack-plugin
module.exports =  {"caption":"ProgressBar__caption--AbeI8","progress":"ProgressBar__progress--roIqu"};